export const INVENTORY_LOOKUP = {
   PALLETTYPE_FIELD : 'PalletType',
   FROM_PALLET_TYPE : 'fromPalletType',
   TO_PALLET_TYPE : 'toPalletType',
   PALLETTYPETD : 'palletTypetd',
   STORER_NAME : 'storerName',
   STORER_KEY : 'storerKey',
   FROM_STORER_KEY : 'fromStorerKey',
   TO_STORER_KEY : 'toStorer',
   FACILITY_NAME : 'facility',
   FROM_FACILITY : 'fromFacility',
   TO_FACILITY : 'toFacility',
   STATUS_LOG_FILTER1 : 'documentNum',
   STATUS_LOG_FILTER2 : 'tableName',
   STATUS_LOG_FILTER2_VAL : 'KITEXTNSTS',
   STATUS_LOG_TD : 'kitstatuslogtd',
   EXTERN_STATUS : 'externStatus',
   PACK_KEY : 'packKey',
   COMMODITY : 'commodity',
   LOC : 'loc',
   STATUS_LOG_SORT_COLUMN : 'editDate',
   PALLETTYPE_QC_FIELD : 'palletType',
   TO_PALLETTYPE_FIELD : 'toPalletType',
}

export const KITTING_STATUS = {
   FINALIZED : '9',
}

export const EXPLODE_KIT = {
   NO_ROW : 0,
   SINGLE_ROW : 1,
}
export const DYNAMIC_BUTTONS = {
   RCM01 : 'RCM01',
   RCM02 : 'RCM02',
   RCM03 : 'RCM03',
   RCM04 : 'RCM04',
   RCM05 : 'RCM05'
}


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/inventory/vas/kitting/kitting.constants.ts